import VueRouter from "vue-router";
import Vue from "vue";
import Wrapper from "./modules/Wrapper";
import MemoryWrapper from "./modules/MemoryWrapper";
import Login from "./modules/auth/Login";
import Registration from "./modules/auth/Registration";
import Email from "./modules/auth/password/Email";
import Reset from "./modules/auth/password/Reset";
import free from "./modules/create/free";
import pay from "./modules/create/pay";
import tariffs from "./modules/create/tariffs";
import AddMaster from "./modules/admin/master/AddMaster";
import AddLocation from "./modules/admin/locations/addLocation";
import AddPage from "./modules/admin/page/AddPage";
import EditPartner from "./modules/admin/partner/EditPartner";
import AddResponsible from "./modules/admin/responsible/AddResponsible";
import UserProfile from "./modules/profile/UserProfile";
import PartnerProfile from "./modules/profile/PartnerProfile";
import pagePassword from "./modules/cabinet/pagePassword";
import MasterAddResponsible from "./modules/master/responsible/AddResponsible";
import editBurial from "./modules/cabinet/editBurial";
import StatisticModal from "./modules/admin/partner/StatisticModal";
import popupPay from "./modules/cabinet/purchases/popup";
import PartnerAddResponsible from "./modules/partner/responsible/PartnerAddResponsible";
import Search from "./components/Search";
import ShortPageLimit from "./vue/ShortPageLimit";
import FeedbackForPartner from "./vue/FeedbackForPartner";
import { Lang } from "./utils/lang";
import Delivery from "./modules/delivery/Delivery";
import ServicesForm from "./modules/services/ServicesForm";
import FamilytreeFeedback from "./modules/family-tree/FamilytreeFeedback";
import PlaceLandingFeedback from "./modules/place/PlaceLandingFeedback";
import MemoriesFeedback from "./modules/memories/MemoriesLandingFeedback";
import AddLang from "./modules/admin/langs/AddLang";
import EditMoment from "./modules/memories/MemoriesEditMoment";
import SetPasswordPopup from "./components/SetPasswordPopup";
import MemoriesPageAlbum from "./modules/memories/MemoriesPageAlbum";
import SetEmailPopup from "./components/SetEmailPopup";
import MasterOnboarding from "./modules/master/onboarding/MasterOnboarding";
import AdminPromoCodesAdd from "./modules/admin/promoCodes/AdminPromoCodesAdd";
import MainPageVideoFrame from "./modules/page/MainPageVideoFrame";
import DeliveryExternalAppeal from "./modules/delivery/DeliveryExternalAppeal.vue";
import copyright from "./modules/cabinet/purchases/copyright.vue";
import StatisticModalPartner from "./modules/admin/partner/StatisticModalPartner.vue";

Vue.use(VueRouter);
Vue.use(Lang);

let router = new VueRouter({
    base: window.laravel.prefix,
    mode: "history",
    routes: [
        {
            path: "/",
            name: "front",
            children: [
                {
                    path: "page/:slug(\\d+)",
                    name: "show-page",
                    props: true
                },
                {
                    path: "/page/prices#get-discount",
                    name: "get-discount"
                },
                {
                    path: "/page/prices",
                    name: "prices"
                },
                {
                    path: "memory",
                    name: "memory"
                },
                {
                    path: "memory_private",
                    name: "memory-private"
                },
                {
                    path: "place",
                    name: "place"
                },
                {
                    path: "place/cost",
                    name: "place-cost"
                },
                {
                    path: "archive/:statusId?",
                    name: "archive"
                },
                {
                    path: "activate-service",
                    name: "activate-service"
                },
            ]
        },
        {
            path: "/",
            component: Wrapper,
            name: "wrapper",
            children: [
                {
                    path: "cabinet/add/partner",
                    component: EditPartner,
                    name: "admin-add-partner"
                },
                {
                    path: "cabinet/partners/:id(\\d+)/edit",
                    component: EditPartner,
                    name: "admin-edit-partner"
                },
                {
                    path: "cabinet/add/master",
                    component: AddMaster,
                    name: "admin-add-master"
                },
                {
                    path: "cabinet/masters/:id(\\d+)/edit",
                    component: AddMaster,
                    name: "admin-edit-master"
                },
                {
                    path: "cabinet/add/responsible",
                    component: AddResponsible,
                    name: "admin-add-responsible"
                },
                {
                    path: "cabinet/responsibles/:id(\\d+)/edit",
                    component: AddResponsible,
                    name: "admin-edit-responsible"
                },
                {
                    path: "cabinet/add/location",
                    component: AddLocation,
                    name: "admin-add-location"
                },
                {
                    path: "cabinet/add/location/:id(\\d+)",
                    component: AddLocation,
                    name: "admin-edit-location"
                },
                {
                    path: "cabinet/lang/add",
                    component: AddLang,
                    name: "admin-add-lang"
                },
                {
                    path: "cabinet/lang/:id(\\d+)/edit",
                    component: AddLang,
                    name: "admin-edit-lang",
                    props: true
                },
                {
                    path: "cabinet/partners/:id(\\d+)/statistic",
                    component: StatisticModal,
                    name: "admin-statistic-partners"
                },
                {
                    path: "cabinet/partners/export-statistic",
                    component: StatisticModalPartner,
                    name: "partners-export-statistic"
                },
                {
                    path: "cabinet/masters/export-statistic",
                    component: StatisticModal,
                    name: "partner-export-statistic"
                },
                {
                    path: "cabinet/add/responsible",
                    component: PartnerAddResponsible,
                    name: "partner-add-responsible"
                },
                {
                    path: "cabinet/responsibles/:id(\\d+)/edit",
                    component: PartnerAddResponsible,
                    name: "partner-edit-responsible"
                },
                {
                    path: "cabinet/add/responsible",
                    component: MasterAddResponsible,
                    name: "master-responsible",
                    props: true
                },
                {
                    path: "cabinet/edit/:id(\\d+)",
                    component: MasterAddResponsible,
                    name: "master-edit-responsible",
                    props: true
                },
                {
                    path: "cabinet/onboarding",
                    component: MasterOnboarding,
                    name: "master-onboarding",
                    props: true
                },
                {
                    path: "cabinet/page/add",
                    component: AddPage,
                    name: "cabinet-add-page",
                    props: true
                },
                {
                    path: "cabinet/create/free",
                    component: free,
                    name: "cabinet-create-free",
                    props: true
                },
                {
                    path: "cabinet/create/pay",
                    component: pay,
                    name: "cabinet-create-pay",
                    props: true
                },
                {
                    path: "cabinet/page/password",
                    component: pagePassword,
                    name: "cabinet-page-password",
                    props: true
                },
                {
                    path: "cabinet/page/related/edit",
                    component: editBurial,
                    name: "cabinet-edit-burial",
                    props: true
                },
                {
                    path: "cabinet/page/:id(\\d+)/expand",
                    component: Delivery,
                    name: "cabinet-expand-page",
                    props: true
                },
                {
                    path: "cabinet/page/:id(\\d+)/external-expand",
                    component: DeliveryExternalAppeal,
                    name: "cabinet-external-expand-page"
                },
                {
                    path: "auth/login",
                    component: Login,
                    name: "login",
                    props: true
                },
                {
                    path: "auth/registration",
                    component: Registration,
                    name: "registration"
                },
                {
                    path: "video",
                    component: MainPageVideoFrame,
                    name: "MainPageVideoFrame"
                },
                {
                    path: "auth/reset-password",
                    component: Email,
                    name: "reset-password",
                    props: true
                },
                {
                    path: "auth/reset",
                    component: Reset,
                    name: "reset"
                },
                {
                    path: "create/free",
                    component: free,
                    name: "free",
                    props: true
                },
                {
                    path: "create/pay",
                    component: pay,
                    name: "pay",
                    props: true
                },
                {
                    path: "create/tariffs",
                    component: tariffs,
                    name: "tariffs"
                },
                {
                    path: "related/edit",
                    component: editBurial,
                    name: "rename-burial",
                    props: true
                },
                {
                    path: "pay/service",
                    component: popupPay,
                    name: "pay-service",
                    props: true
                },
                {
                    path: "pay/service/delivery",
                    component: Delivery,
                    name: "pay-service-delivery",
                    props: true
                },
                {
                    path: "cabinet/purchases/copyright",
                    component: copyright,
                    name: "pay-copyright"
                },
                {
                    path: "short-page-limit",
                    component: ShortPageLimit,
                    name: "shortPageLimit"
                },
                {
                    path: "corporate-partner/feedback",
                    component: FeedbackForPartner,
                    name: "corporate"
                },
                {
                    path: "cabinet-program/feedback",
                    component: FeedbackForPartner,
                    name: "program",
                    props: true
                },
                {
                    path: "feedback",
                    component: ServicesForm,
                    name: "feedback",
                    props: true
                },
                {
                    path: "familytree/feedback",
                    component: FamilytreeFeedback,
                    name: "familytree-feedback",
                    props: true
                },
                {
                    path: "place/feedback",
                    component: PlaceLandingFeedback,
                    name: "place-feedback",
                    props: true
                },
                {
                    path: "set-password",
                    component: SetPasswordPopup,
                    name: "edit-password",
                    props: true
                },
                {
                    path: "set-email",
                    component: SetEmailPopup,
                    name: "set-email",
                    props: true
                },
                {
                    path: "order",
                    component: Delivery,
                    name: "order",
                    props: true
                },
                {
                    path: "page/service/copyright",
                    component: ServicesForm,
                    name: "copyright",
                    props: true
                },
                {
                    path: "page/service/video",
                    component: ServicesForm,
                    name: "video",
                    props: true
                },
                {
                    path: "page/service/table",
                    component: ServicesForm,
                    name: "table",
                    props: true
                },
                {
                    path: "memories/feedback",
                    component: MemoriesFeedback,
                    name: "memories-feedback",
                    props: true
                },
                {
                    path: "memories/moment/add",
                    component: EditMoment,
                    name: "profile-add-moment"
                },
                {
                    path: "memories/moment/edit",
                    component: EditMoment,
                    name: "profile-edit-moment",
                    props: true
                },
                {
                    path: "profile/user",
                    component: UserProfile,
                    name: "profile-user"
                },
                {
                    path: "profile/partner",
                    component: PartnerProfile,
                    name: "profile-partner"
                },
                {
                    path: "cabinet/promo-codes/add",
                    component: AdminPromoCodesAdd,
                    name: "promo-codes-add"
                },
                {
                    path: "cabinet/promo-codes/:id/edit",
                    component: AdminPromoCodesAdd,
                    name: "promo-codes-edit"
                }
            ]
        },
        {
            path: "/cabinet",
            name: "cabinet",
            children: [
                {
                    path: "partners",
                    name: "admin-partners"
                },
                {
                    path: "partners/:partnerId(\\d+)/statistics",
                    name: "partner-statistics"
                },
                {
                    path: "page/:slug(\\d+)",
                    name: "admin-edit-page"
                },
                {
                    path: "news/:id(\\d+)/edit",
                    name: "admin-edit-news"
                },
                {
                    path: "place/:id(\\d+)/edit",
                    name: "admin-edit-memorial"
                },
                {
                    path: "pages",
                    name: "admin-pages"
                },
                {
                    path: "masters",
                    name: "admin-masters"
                },
                {
                    path: "responsibles",
                    name: "admin-responsibles"
                },
                {
                    path: "edit",
                    component: editBurial,
                    name: "admin-edit-burial-name",
                    props: true
                },
                {
                    path: "partners/:partnerId(\\d+)/banner",
                    name: "admin-banner"
                },
                {
                    path: "responsibles",
                    name: "partner-responsibles"
                },
                {
                    path: "pages",
                    name: "partner-pages"
                },
                {
                    path: "page/:slug(\\d+)",
                    name: "partner-edit-page"
                },
                {
                    path: "masters",
                    name: "partner-masters"
                },
                {
                    path: "banner/:partnerId(\\d+)",
                    name: "partner-banner"
                },
                {
                    path: "place/:id(\\d+)/edit",
                    name: "partner-edit-memorial"
                },
                {
                    path: "responsibles",
                    name: "master-responsibles"
                },
                {
                    path: "pages",
                    name: "master-pages"
                },
                {
                    path: "page/:slug(\\d+)",
                    name: "master-edit-page"
                },
                {
                    path: "place/:id(\\d+)/edit",
                    name: "master-edit-memorial"
                },
                {
                    path: "page/:slug(\\d+)",
                    name: "user-edit-page"
                },
                {
                    path: "pages",
                    name: "user-pages",
                    props: true
                },
                {
                    path: "articles/:id(\\d+)/edit",
                    name: "admin-edit-article"
                },
                {
                    name: "promo-codes",
                    path: "promo-codes"
                },
                {
                    name: "qr-codes",
                    path: "qr-codes"
                },
                {
                    name: "promo-subscriptions",
                    path: "promo-subscriptions"
                },
            ]
        },
        {
            path: "/search",
            component: Search,
            name: "search"
        },
        {
            path: "/memories/:slug(\\d+)/album",
            component: MemoryWrapper,
            children: [
                {
                    path: ":id(\\d+)",
                    component: MemoriesPageAlbum,
                    name: "memories-album",
                    props: true
                }
            ]
        },
    ]
});

export { router };
